<template>
  <wallet-card>
    <template #header>
      <img
        :src="`/assets/sf/image/icon_${itemData.type}.png`"
        class="header__icon"
      />
      <strong class="header__title"
        >{{ `${itemData.coinSymbol}-${itemData.type.toUpperCase()}` }}<br />CAKE
        LP<img
          src="/assets/sf/image/logo_pancake-swap.png"
          alt="pancake swap"
          class="header__pancake-icon"
      /></strong>
      <span class="header__tag">{{ itemData.temperature }} °C</span>
      <small class="header__note">
        {{ itemData.description }}
      </small>
    </template>

    <template #body>
      <p class="apr">
        <em class="apr__label">APR：</em>
        <span class="apr__num">{{ toFormattedApr(itemData.apy) }} %</span>
      </p>
      <p class="earn">
        <em class="earn__label">Earn：</em>
        <span class="earn__type">
          {{ itemData.rewardTokenSymbol }}
        </span>
      </p>

      <p class="body-box body-box--earned">
        <span class="body-box__label"
          >{{ itemData.rewardTokenSymbol }} Earned</span
        >
        <em
          :class="[
            'body-box__num',
            { '--none': !$store.state.isLogin && itemData.account.earned <= 0 },
          ]"
          >{{
            $store.state.isLogin && itemData.account.earned >= 0
              ? toFormattedToken(itemData.account.earned)
              : "0.00000"
          }}</em
        >
        <input-button
          :size="'medium'"
          :disabled="!$store.state.isLogin || itemData.account.earned <= 0"
          @click="harvest(itemData)"
          >Harvest</input-button
        >
      </p>
      <p
        class="body-box body-box--staked"
        v-if="itemData.apy == 0 || isFinished"
      >
        <input-button :size="'large'" :disabled="true"
          >Connect Wallet</input-button
        >
      </p>
      <p class="body-box body-box--staked" v-else>
        <template
          v-if="
            $store.state.isLogin &&
            itemData.account.isApproved &&
            itemData.account.staked > 0
          "
        >
          <span class="body-box__label">{{
            `${
              itemData.coinSymbol
            }-${itemData.type.toUpperCase()} CAKE LP Staked`
          }}</span>

          <em class="body-box__num">{{
            toFormattedToken(itemData.account.staked)
          }}</em>

          <span class="staked-buttons">
            <button class="staked-button" @click="withdraw(itemData)">
              <svg-icon class="icon" :icon="'minus'" />
            </button>
            <button
              class="staked-button"
              @click="deposit(itemData)"
              v-if="!isFinished && !isFull"
            >
              <svg-icon class="icon" :icon="'plus'" />
            </button>
          </span>
        </template>
        <input-button
          v-else-if="
            $store.state.isLogin &&
            !itemData.account.isApproved &&
            (!isFinished || !isFull)
          "
          :size="'large'"
          :is-loading="isLoading"
          :disabled="isLoading"
          @click="approve(itemData)"
          >{{ isLoading ? "Approving" : "Approve" }}</input-button
        >
        <input-button
          v-else-if="
            $store.state.isLogin &&
            itemData.account.isApproved &&
            itemData.account.staked <= 0 &&
            (!isFinished || !isFull)
          "
          :size="'large'"
          :disabled="isFinished || isFull"
          @click="deposit(itemData)"
          >STAKE</input-button
        >
        <input-button
          v-else
          :size="'large'"
          @click="openModal('modal-connect-wallet')"
          >Connect Wallet</input-button
        >
      </p>
    </template>

    <template #detail>
      <span class="detail__data__total">
        <span>Total liquidity:</span>
        <span>$ {{ toCurrency(itemData.totalLiqudity) }}</span>
      </span>
      <span class="detail__data__link"
        ><a :href="itemData.swapUrl" target="_blank"
          >{{
            `Get CAKE-LP（${
              itemData.coinSymbol
            }-${itemData.type.toUpperCase()})`
          }}<svg-icon class="icon" :icon="'new_window'" /></a
      ></span>
      <span class="detail__data__link"
        ><a :href="itemData.url" target="_blank"
          >View Contract<svg-icon class="icon" :icon="'new_window'" /></a
      ></span>
      <span class="detail__data__link"
        ><a :href="itemData.pairUrl" target="_blank"
          >See Pair Info<svg-icon class="icon" :icon="'new_window'" /></a
      ></span>
    </template>
  </wallet-card>
</template>

<script>
import InputButton from "@/components/atoms/InputButton";
import SvgIcon from "@/components/atoms/SvgIcon";
import WalletCard from "@/components/molecules/WalletCard";
import { getPools } from "@/utils/cakeLpFarming";
import numFormat from "number-format.js";
import cakeLps from "@/domain/cakeLpFarming/cakeLps";
import { MAX_UINT256 } from "@/utils/constants";

export default {
  name: "CakelpFarmingCard",
  components: {
    InputButton,
    SvgIcon,
    WalletCard,
  },
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      isDetail: false,
      isLoading: false,
      checkStatusInterval: null,
    };
  },
  computed: {
    isFull() {
      return false;
    },
    isFinished() {
      return this.itemData.isFinished;
    },
    account() {
      return this.$store.state.account;
    },
    web3() {
      return this.$store.state.web3;
    },
  },
  methods: {
    toFormattedToken(num) {
      return numFormat(
        "#,##0.00000",
        this.web3.instance.utils.fromWei(num, "ether")
      );
    },
    toFormattedApr(num) {
      return numFormat("#,##0.00", num);
    },
    toCurrency(num) {
      return numFormat("#,##0.00", num);
    },
    openModal(target) {
      this.$store.dispatch("openModal", target);
    },
    deposit(farmingPool) {
      this.$store.dispatch("deposit/updateStakingPool", farmingPool);

      this.itemData.account.balance == 0
        ? this.$store.dispatch("openModal", "get-cakelp-modal")
        : this.$store.dispatch("openModal", "cakelp-farming-stake-modal");
    },
    withdraw(farmingPool) {
      this.$store.dispatch("withdraw/updateStakingPool", farmingPool);
      this.$store.dispatch("openModal", "cakelp-farming-unstake-modal");
    },
    harvest(farmingPool) {
      this.$store.dispatch("harvest/updateStakingPool", farmingPool);
      this.$store.dispatch("openModal", "cakelp-farming-harvest-modal");
    },
    approve(farmingPool) {
      this.isLoading = true;

      const accountAddress = this.account.address;
      let lpPool = null;
      if (farmingPool.type == "bnb") {
        lpPool = cakeLps[0];
      }
      if (farmingPool.type == "busd") {
        lpPool = cakeLps[1];
      }

      let lpPoolContract = new this.web3.instance.eth.Contract(
        lpPool.abi,
        lpPool.contractAddress
      );

      lpPoolContract.methods
        .approve(farmingPool.stakeContractAddress, MAX_UINT256)
        .send({ from: accountAddress })
        .on("transactionHash", (transactionHash) => {
          this.checkTransactionStatus(transactionHash, 3);
        })
        .on("error", () => {
          this.incompleteTransaction();
        });
    },
    checkTransactionStatus(transactionHash, seconds) {
      this.checkStatusInterval = setInterval(() => {
        this.web3.instance.eth
          .getTransactionReceipt(transactionHash)
          .then((result) => {
            if (result) {
              if (result.status) {
                clearInterval(this.checkStatusInterval);
                this.completeTransaction();
              }
            }
          });
      }, seconds * 1000);
    },
    completeTransaction() {
      getPools(this.web3.instance, this.account.address).then((result) => {
        this.$store.dispatch("cakeLpFarmings/updatePools", result);

        this.isLoading = false;

        this.$store.dispatch("toast/updateToast", {
          type: "success",
          title: "Contract Enabled",
          message: "You can now stake in the CAKE LP pool!",
        });
      });
    },
    incompleteTransaction() {
      this.isLoading = false;

      this.$store.dispatch("toast/updateToast", {
        type: "error",
        title: "Canceled",
        message: "Please try again and confirm the transaction.",
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.checkStatusInterval);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.header {
  &__title {
    font-size: 1.8rem;
    font-weight: 800;
    grid-column: 2;
    line-height: 1.2;
    align-self: center;
  }
  &__icon {
    width: 54px;
    height: 54px;
    align-self: center;
  }
  &__note {
    font-weight: 600;
    color: $color-font-note;
    grid-row: 2;
    grid-column: 2;
    font-size: 1.2rem;
  }
  &__tag {
    font-size: 1.1rem;
    height: 32px;
    line-height: 28px;
    border: 2px solid;
    padding: 0 16px;
    border-radius: 16px;
    display: inline-block;
    font-weight: bold;
    grid-column: 3;
  }
  &__pancake-icon {
    width: 24px;
    height: 24px;
    margin: -0.2em 0 0 0.5em;
    vertical-align: middle;
    display: inline-block;
  }
}
.body-box {
  display: grid;
  grid-template-columns: 1fr auto;

  &--earned {
    margin-bottom: 40px;
  }
  &--staked {
    margin-bottom: 24px;
  }
  &__label {
    font-size: 1.2rem;
    display: block;
    font-weight: 600;
    color: $color-primary;
    margin-bottom: 8px;
    grid-column: 1/3;
  }
  &__num {
    font-size: 1.7rem;
    font-weight: 700;
    align-self: center;

    &.--none {
      color: $color-disabled;
    }
  }
}
.apr {
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 0.5em;
  font-size: 1.6rem;

  &__label {
    font-weight: 600;
  }
  &__num {
    font-weight: 500;
  }
}
.earn {
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 32px;

  &__label {
    font-size: 1.6rem;
    font-weight: 600;
  }
  &__type {
    font-size: 1.6rem;
    font-weight: 500;
  }
}
.detail {
  &__data {
    &__total {
      margin-bottom: 24px;
      display: flex;
      justify-content: space-between;
    }
    &__link {
      display: block;
      text-align: right;

      &:not(:last-child) {
        margin-bottom: 1em;
      }
      a {
        color: $color-font-note;
      }
      .icon {
        width: 0.85em;
        height: 0.85em;
        fill: $color-link;
        display: inline-block;
        vertical-align: middle;
        margin: -0.2em 0 0 8px;
      }
      .wallet-icon {
        width: 1.5em;
        height: 1.5em;
        display: inline-block;
        vertical-align: middle;
        margin: -0.2em 0 0 8px;
      }
    }
  }
}

/** stake and unstaked buttons */
.staked-buttons {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 1fr;
}
.staked-button {
  font-size: 0;
  background: $gradation-horizontal;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 3px;

  .icon {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    fill: var(--color_bg_parts);
  }
}
</style>